import { clsx } from "clsx";
import type { FC } from "react";
import { useSeparator } from "react-aria";

import style from "./HeaderDivider.module.css";

const HeaderDivider: FC<{ invisible?: boolean }> = ({ invisible }) => {
  const { separatorProps } = useSeparator({ orientation: "horizontal" });

  return <div {...separatorProps} className={clsx(style.divider, { [style.divider_invisible]: invisible })} />;
};

export { HeaderDivider };
